export const pricePrecision = 2;
